module.exports = __webpack_public_path__ + "static/media/slick.eot";


//////////////////
// WEBPACK FOOTER
// ./~/slick-carousel/slick/fonts/slick.eot
// module id = 858
// module chunks = 3